(() => {
  let key = new URL(location.href).searchParams.get('bb_edit')
  const template = document.getElementById('bb-cart-edit-template')
  if (!key || !template) return
  const root = window.Shopify?.routes?.root || '/'
  const banner = template.content.firstElementChild.cloneNode(true)
  const status = banner.querySelector('[role="status"]')
  const labels = banner.dataset
  let form, engine, item, button, originalButton, ready = false, busy = false, finished = false
  let revision = 0, checking = false, pendingProperties = null
  const bar = document.getElementById('bb-buy-bar')
  const originalBar = bar && {
    add: bar.dataset.addLabel || bar.querySelector('[data-bb-buy-bar-add]')?.textContent,
    adding: bar.dataset.addingLabel || bar.dataset.addLabel
  }
  document.documentElement.classList.add('bb-editing-cart')
  status.textContent = labels.loading
  const main = document.getElementById('MainContent')
  main.prepend(banner)
  banner.querySelector('[data-bb-cart-edit-return]')?.addEventListener('click', event => {
    event.preventDefault()
    event.stopPropagation()
    event.currentTarget.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }))
  })

  async function getCart() {
    const response = await fetch(root + 'cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
    if (!response.ok) throw new Error('cart')
    return response.json()
  }

  function setLabel(text) {
    if (button) {
      const label = button.querySelector('[data-add-to-cart-text], .element-button__text, .btn__text')
      if (label) label.textContent = text
      else button.textContent = text
    }
    if (bar) {
      bar.dataset.addLabel = text
      bar.dataset.addingLabel = labels.updating
      const proxy = bar.querySelector('[data-bb-buy-bar-add]')
      if (proxy) proxy.textContent = text
    }
    document.dispatchEvent(new CustomEvent('bb:cart-edit-state'))
  }

  function setBusy(value) {
    busy = value
    if (button) {
      button.disabled = value
      button.setAttribute('aria-busy', String(value))
    }
    banner.setAttribute('aria-busy', String(value))
    if (!finished) setLabel(value ? labels.updating : labels.update)
  }

  function setKey(value) {
    key = value
    const url = new URL(location.href)
    if (key) url.searchParams.set('bb_edit', key)
    else url.searchParams.delete('bb_edit')
    history.replaceState(history.state, '', url)
  }

  function sameProperties(left, right) {
    const entries = value => Object.entries(value || {})
      .filter(([, entry]) => entry != null && String(entry) !== '')
      .map(([name, entry]) => [name, String(entry)])
      .sort(([a], [b]) => a.localeCompare(b))
    return JSON.stringify(entries(left)) === JSON.stringify(entries(right))
  }

  function matchingLine(cart, properties) {
    const matches = cart.items.filter(line => String(line.variant_id) === String(item.variant_id)
      && String(line.selling_plan_allocation?.selling_plan?.id || '') === String(item.selling_plan_allocation?.selling_plan?.id || '')
      && sameProperties(line.properties, properties))
    return matches.length === 1 ? matches[0] : null
  }

  function currentLine(cart) {
    return cart.items.find(line => line.key === key)
      || matchingLine(cart, item.properties)
      || (pendingProperties && matchingLine(cart, pendingProperties))
  }

  function useLine(line) {
    item = line
    setKey(line.key)
  }

  function finishEditing() {
    finished = true
    ready = false
    revision++
    setKey(null)
    document.documentElement.classList.remove('bb-editing-cart')
    document.removeEventListener('click', update, true)
    document.removeEventListener('submit', update, true)
    setBusy(false)
    if (button && originalButton != null) button.innerHTML = originalButton
    if (bar && originalBar) {
      bar.dataset.addLabel = originalBar.add
      bar.dataset.addingLabel = originalBar.adding
      const proxy = bar.querySelector('[data-bb-buy-bar-add]')
      if (proxy) proxy.textContent = originalBar.add
    }
    status.textContent = labels.missing
    document.dispatchEvent(new CustomEvent('bb:cart-edit-state'))
  }

  function acceptCart(cart) {
    if (finished || busy || !ready || !Array.isArray(cart?.items)) return
    const line = currentLine(cart)
    if (line) useLine(line)
    else finishEditing()
  }

  async function checkCart() {
    if (finished || busy || !ready || checking) return
    const expected = revision
    checking = true
    try {
      const cart = await getCart()
      if (revision === expected) acceptCart(cart)
    } catch (_) {
    } finally {
      checking = false
    }
  }

  async function update(event) {
    if (finished) return
    const trigger = event.target.closest?.('button[name="add"], button[type="submit"], input[type="submit"]')
    const targetForm = event.type === 'submit' ? event.target
      : trigger?.form || trigger?.closest('form[action*="/cart/add"]')
    const submit = event.type === 'submit' || trigger
    if (!submit || !targetForm || !main.contains(targetForm) || (form && targetForm !== form)) return
    event.preventDefault()
    event.stopImmediatePropagation()
    if (!ready || busy) return
    try {
      if (window.BBEngraving && !window.BBEngraving.validate(form)) return
      if (!form.reportValidity()) return
      if (!engine.beforeCartAction()) return
      engine.beforeCartActionSync(true)
      engine.syncFormPropertiesPopupSliderToMainForm?.()
      if (engine.useAddToCartByAddOn()) {
        status.textContent = labels.unavailable
        return
      }
      const data = new FormData(form)
      if (String(data.get('id')) !== String(item.variant_id)) {
        status.textContent = labels.unavailable
        return
      }
      const properties = {}
      Object.entries(item.properties || {}).forEach(([name, value]) => {
        if (name.startsWith('_') && !name.startsWith('_apo_') && name !== '_has_apo') properties[name] = value
      })
      for (const [name, value] of data.entries()) {
        const match = name.match(/^properties\[(.*)\]$/)
        if (match && typeof value === 'string') properties[match[1]] = value
      }
      setBusy(true)
      revision++
      const cart = await getCart()
      const current = currentLine(cart)
      if (!current) {
        finishEditing()
        return
      }
      useLine(current)
      pendingProperties = properties
      const response = await fetch(root + 'cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: current.quantity, properties, sections: 'cart-ajax' })
      })
      if (!response.ok) throw new Error('update')
      const state = await response.json()
      const updated = matchingLine(state, properties)
      if (!updated) throw new Error('confirm')
      useLine(updated)
      pendingProperties = null
      status.textContent = labels.saved
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: state, addToCartBtn: button }, bubbles: true }))
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: state } }))
    } catch (_) {
      status.textContent = labels.error
    } finally {
      if (busy) setBusy(false)
    }
  }

  document.addEventListener('click', update, true)
  document.addEventListener('submit', update, true)
  document.addEventListener('cart:updated', event => acceptCart(event.detail?.cart))
  document.addEventListener('ajaxProduct:added', () => {
    if (finished) banner.remove()
  })
  document.addEventListener('bb:cart-refreshed', checkCart)
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') checkCart()
  })
  window.addEventListener('pageshow', checkCart)

  async function initialize() {
    try {
      const cart = await getCart()
      item = cart.items.find(line => line.key === key)
      if (!item) {
        finishEditing()
        return
      }
      const start = Date.now()
      while (Date.now() - start < 15000) {
        const container = [...main.querySelectorAll('.avpoptions-container__v2')].find(node => node.__apoEngine)
        engine = container?.__apoEngine
        form = engine?.mainProductForm || engine?.productForm
        if (engine?.propertiesMainSync?.syncAllPropertiesToStore && form && String(new FormData(form).get('id')) === String(item.variant_id)) break
        engine = null
        await new Promise(resolve => setTimeout(resolve, 100))
      }
      if (!engine || !form || typeof engine.mount !== 'function') throw new Error('unavailable')
      button = form.querySelector('button[name="add"], [type="submit"].add-to-cart, button[type="submit"]')
      if (!button) throw new Error('unavailable')
      originalButton = button.innerHTML
      const values = new Map(Object.entries(item.properties || {}).filter(([name]) => !name.startsWith('_')))
      engine.propertiesMainSync.syncAllPropertiesToStore(values)
      engine.mount(true)
      engine.root.before(banner)
      const quantity = form.querySelector('[name="quantity"]')
      if (quantity) quantity.value = item.quantity
      ready = true
      setLabel(labels.update)
      status.textContent = labels.intro
      banner.scrollIntoView({ block: 'center' })
    } catch (error) {
      status.textContent = error.message === 'missing' ? labels.missing : labels.unavailable
    }
  }
  initialize()
})()
